import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IUpdateLanguagePayload } from '@app-store/slices/localization/updateLanguage'
import store from '@app-store/store'

interface TaskAction extends Action {
    payload: IUpdateLanguagePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.localization.updateLanguage

function* updateLanguageSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post('/users/language', payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            store.dispatch(rootActions.localization.languageTypes.onRequest())
            if (payload.sagaCB) {
                payload.sagaCB?.onSuccess()
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* updateLanguageSaga(): any {
    yield takeLatest<TaskAction>(onRequest, updateLanguageSagaTask)
}

export default updateLanguageSaga
